import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { CryptoService } from 'src/app/services/crypto/crypto.service';
import { styleSheetInterface } from 'src/app/util/interfaces/styleSheet';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class StylesheetService {
	private stylesheetUrl = environment.baseApiUrl + 'register/stylesheet';
	private stylesheetIdUrl = environment.baseApiUrl + 'register/stylesheet/{idStylesheet}';
	private getStyleSheetDataUrl = environment.baseApiUrl + 'customer/stylesheet/{idStyleSheet}';

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService,
		private CryptoService: CryptoService
	) {}

	createStylesheet(stylesheetBody: styleSheetInterface): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		return this.http.post<any>(this.stylesheetUrl, stylesheetBody, { headers: headers });
	}

	getStyleSheetData(idStyleSheet: string): Observable<styleSheetInterface> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const getStyleSheetDataUrl = this.getStyleSheetDataUrl.replace('{idStyleSheet}', idStyleSheet);
		return this.http.get<any>(getStyleSheetDataUrl, { headers: headers }).pipe(
			map((styleSheetRes) => {
				const newStyleSheet: styleSheetInterface = {
					id: styleSheetRes.id,
					name: styleSheetRes.name,
					default: styleSheetRes.default,
					'primary-color-1': styleSheetRes['primary-color-1'],
					'primary-color-1-dark-mode': styleSheetRes['primary-color-1-dark-mode'],
					'primary-color-2': styleSheetRes['primary-color-2'],
					'primary-color-2-dark-mode': styleSheetRes['primary-color-2-dark-mode'],
					app_source: styleSheetRes.app_source,
					logo: {
						content: '',
						checkSum: '',
						extension: ''.toLowerCase(),
						mimeType: '',
						file_path: '',
						name: '',
						size: 0,
					},
				};

				if (styleSheetRes.logo) {
					newStyleSheet.logo.content = this.CryptoService.fuseB64Key(styleSheetRes.logo.content);
					newStyleSheet.logo.checkSum = styleSheetRes.logo.content;
					newStyleSheet.logo.extension = styleSheetRes.logo.extension;
					newStyleSheet.logo.mimeType = styleSheetRes.logo.mimeType;
					newStyleSheet.logo.file_path = styleSheetRes.logo.file_path;
					newStyleSheet.logo.name = styleSheetRes.logo.name;
				}

				return newStyleSheet;
			})
		);
	}

	updateStylesheet(stylesheet: styleSheetInterface): Observable<JSON> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const stylesheetIdUrl = this.stylesheetIdUrl.replace('{idStylesheet}', stylesheet.id);
		return this.http.put<JSON>(stylesheetIdUrl, stylesheet, { headers: headers });
	}

	deleteStylesheet(stylesheetId: string): Observable<JSON> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const stylesheetIdUrl = this.stylesheetIdUrl.replace('{idStylesheet}', stylesheetId);
		return this.http.delete<JSON>(stylesheetIdUrl, { headers: headers });
	}
}
